import axios from 'src/utils/axios';
import { loadIsler } from 'src/utils/storage/WorkOrder';
import moment from 'moment';

// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr);
  }
  setUserSessionFromLocale();
  return localStorage.getItem('user');
};






export const moneyFormat = (Price, CountryCode, Currency) => new Intl.NumberFormat(CountryCode, {
  style: 'currency',
  currency: Currency,
  minimumFractionDigits: 2
}).formatToParts(Price).map(
  (p) => (p.type != 'literal' && p.type != 'currency' ? p.value : '')
).join('');


export const setUserMobile = (MobileNumber) => {
  const ChangeuserStr = sessionStorage.getItem('user');
  const ChangeuserStr1 = JSON.parse(ChangeuserStr);
  ChangeuserStr1.MobileNumber = MobileNumber;

  sessionStorage.removeItem('user');
  sessionStorage.setItem('user', JSON.stringify(ChangeuserStr1));

  localStorage.removeItem('user');
  localStorage.setItem('user', JSON.stringify(ChangeuserStr1));
};
// return the token from the session storage
export const getToken = () => sessionStorage.getItem('token') || null;

export const getTokenWs = () => sessionStorage.getItem('tokenWs') || null;

export const getIpAddress = () => localStorage.getItem('IpAddress') || null;

export const setIpAddress = (IpAddress) => {
  localStorage.setItem('IpAddress', IpAddress);
};


// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('tokenWs');
  sessionStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenWs');
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
};

// set the token and user from the session storage
export const setUserSession = (token, tokenWs, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('lastLogin', new Date());
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('user', JSON.stringify(user));
};

export const setInformationPopup = (value) => {
  // localStorage.setItem('InformationPopup', value);
  sessionStorage.setItem('InformationPopup', value);
};

// set the token and user from the session storage
export const setSessionToken = (token, tokenWs) => {
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
};

export const setUserSessionFromLocale = () => {
  const lastLogin = localStorage.getItem('lastLogin');
  const token = localStorage.getItem('token');
  const tokenWs = localStorage.getItem('tokenWs');
  const user = localStorage.getItem('user');
  if (lastLogin === null || token === null || user === null) {
    return false;
  }
  const now = new Date();
  const ll = new Date(lastLogin);
  if (now.getYear() === ll.getYear() && now.getMonth() === ll.getMonth() && now.getDate() === ll.getDate()) {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('tokenWs', tokenWs);
    sessionStorage.setItem('user', user);
    return true;
  }
  return false;
};


export const getKoordinat = (Param) => sessionStorage.getItem(Param) || null;

export const setKoordinat = (Enlem, Boylam,) => {
  sessionStorage.removeItem('Enlem');
  sessionStorage.removeItem('Boylam');
  sessionStorage.setItem('Enlem', Enlem);
  sessionStorage.setItem('Boylam', Boylam);
};

export var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};
function success(pos) {
  const crd = pos.coords;
  setKoordinat(crd.latitude, crd.longitude);
}

function error(err) {
  // console.warn(`ERROR(${err.code}): ${err.message}`);
  // alert('Konum Bilgilerinizi Paylaşmaya İzin Verdikten Sonra Tekrar Giriş Yapınız!..');
  // localStorage.clear();
  // sessionStorage.clear();
  // window.location.href = `${window.location.origin}/auth/login`;
}

export function GetLocation() {
  return navigator.geolocation.getCurrentPosition(success, error, options);
}

export const publishLocation = (musteriNo = 1) => {
  try {
    const isler = loadIsler().filter((d) => parseInt(d.DurumKodu) === 42);

    if (isler.length === 0) {
      return;
    }
    if (parseInt(musteriNo) !== 0 && isler.filter((i) => parseInt(i.MusteriNo) === parseInt(musteriNo)).length === 0) {
      return;
    }
    navigator.geolocation.getCurrentPosition(sendLocation, (error) => console.log(error), options);
  } catch (error) {

  }
};

export const sendLocation = (pos) => {
  const user = getUser();
  // let now = new Date();
  if (user === undefined || user === null) {

  }
  // const data = {
  //   ServiceShopId: user.ServiceShopId,
  //   TechnicianId: user.TechnicianId,
  //   Latitude: pos.coords.latitude,
  //   Longitude: pos.coords.longitude,
  //   CreateDate: now.toLocaleDateString() + ' ' + now.toLocaleTimeString()
  // }
  // const config = {
  //   headers: { 'Content-Type': 'application/json,' }
  // }

  // axios.post('/Location/SetLocation', data, config);
};

// string comparison
export const sc = (str, key) => (str || '').toString().toLocaleLowerCase(localStorage.i18nextLng_normalized).indexOf((key || '').toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)) !== -1;

// return the plate from the session storage
export const getPlate = () => localStorage.getItem('plate') || '';

// update plate.
export const setPlate = (p) => {
  localStorage.removeItem('plate');
  localStorage.setItem('plate', p);
};

// return the tour open from the local storage
export const getTourOpen = () => (localStorage.getItem('tourOpen') !== 'false');

// update tour open.
export const setTourOpen = () => {
  localStorage.removeItem('tourOpen');
  localStorage.setItem('tourOpen', 'false');
};

// return the last phone and sms code
export const getLastSms = () => [localStorage.getItem('SMS_TEL') || '', localStorage.getItem('SMS_KOD') || ''];

// update tour open.
export const setLastSms = (tel, phone) => {
  localStorage.removeItem('SMS_TEL');
  localStorage.removeItem('SMS_KOD');
  localStorage.setItem('SMS_TEL', tel);
  localStorage.setItem('SMS_KOD', phone);
};


export const openBlob = (blob, fileName = 'ArtemisFile') => {
  const fileURL = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = fileURL;
  a.target = '_self';
  a.download = fileName;
  a.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL);
  }, 5000);
};


export const generateCode = (length) => {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const handleLogout = () => {
  // sessionStorage.clear()/localStorage.clear() burada Okta SDK'sinin kendi
  // token deposunu (okta-token-storage) da siliyordu; bu da backend'in
  // uygulama-seviyesi bir 401 dönmesi durumunda hala gecerli olan Okta
  // oturumunun bozulup kullanicinin Okta login ekranina atilmasina yol
  // aciyordu. Sadece uygulamanin kendi oturum anahtarlari temizleniyor.
  removeUserSession();
};

export const handleLogoutMain = () => {


  handleLogout();


  // const dataLogOut = {};
  // const configLogOut = {
  //   headers: { 'Content-Type': 'application/json' }
  // };
  // axios.post('/DeleteToken', dataLogOut, configLogOut)
  //   .then((response) => {
  //     handleLogout();
  //   }).catch((error) => {
  //     handleLogout();
  //   });
};

export const monthsTr = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

export const combineDateTime = (date, time) => {

  const combineDateTime = `${date}T${time}`;
  return combineDateTime;

}

export const RoundKm = (param) => {
  const roundedKm = Math.round(param / 1000);
  return roundedKm;
}